import { Location } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { CbButtonModule } from '@chubb/ui-components';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-generic-error-screen',
  imports: [CbButtonModule],
  templateUrl: './generic-error-screen.component.html',
  styleUrl: './generic-error-screen.component.scss',
})
export class GenericErrorScreenComponent implements OnInit {
  protected readonly _location: Location = inject(Location);
  _route: ActivatedRoute = inject(ActivatedRoute);

  title = '';
  message = '';

  ngOnInit() {
    // check url and set correct message
    const currentPath = this._route.snapshot.url;

    if (currentPath.length < 1) {
      this.title = 'Page Not Found';
      this.message =
        'This can happen if you followed a link to the page from an external page, or because of an internal error.';
    } else {
      switch (currentPath[0].path) {
        case 'access-denied':
          this.title = 'Access Denied';
          this.message = 'This can happen if you cannot login to SalesForce, or because of an internal error.';
          break;
        case 'unknown-error':
          this.title = 'Oops! You have encountered an error.';
          this.message = '';
          break;
        default:
          this.title = 'Page Not Found';
          this.message =
            'This can happen if you followed a link to the page from an external page, or because of an internal error.';
      }
    }
  }

  back() {
    this._location.back();
  }

  getSupport() {
    const supportUrl = environment.supportUrl;
    window.location.href = supportUrl;
  }
}
